const TOKEN_KEY = 'bde_token';
const USER_KEY = 'bde_admin_user';
const PERMISSIONS_KEY = 'bde_permissions';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuth(token, user, permissions) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions || []));
}

export function updateAuthProfile(user, permissions) {
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions || []));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('bde-auth-updated'));
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(PERMISSIONS_KEY);
}

export function getCurrentUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || '{}');
  } catch (e) {
    return {};
  }
}

export function getPermissions() {
  try {
    return JSON.parse(localStorage.getItem(PERMISSIONS_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

export function hasPermission(permission) {
  const permissions = getPermissions();
  return permissions.includes('*') || permissions.includes(permission);
}
